import Link from "next/link";

export default function Logo({ className = "" }: { className?: string }) {
  return (
    <Link href="/" className={`flex items-center gap-2 ${className}`}>
      <svg
        width="26"
        height="26"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M5 22V6L21 22V6"
          stroke="currentColor"
          className="text-slate-900 dark:text-white"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="21" cy="6" r="2.2" fill="#7C3AED" />
      </svg>
      <span className="text-base font-bold uppercase tracking-widest text-slate-900 dark:text-white">
        Nohaya
      </span>
    </Link>
  );
}
